import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { CommonComponent } from 'src/app/shared/components/common-component';
import { ConsultaService } from 'src/core/consulta/consulta.service';
import { Consulta } from 'src/core/consulta/consulta.types';

@Component({
  selector: 'app-detalle-cita-asignada',
  templateUrl: './detalle-cita-asignada.component.html',
  styleUrls: ['./detalle-cita-asignada.component.css']
})
export class DetalleCitaAsignadaComponent extends CommonComponent implements OnInit{

  consulta = {} as Consulta;
  constructor(
    private _consultaService: ConsultaService,
    private _router: Router,
    _snackBar: MatSnackBar
  ){
    super(_snackBar);
  }

  ngOnInit(): void {
    this.getConsulta();
  }

  getConsulta(){
    this._consultaService.Consulta$.subscribe({
      next: (consulta: Consulta) => {
        if (consulta === null){
          this._router.navigateByUrl('vets/scheduled-appointments');
        }
        this.consulta = consulta;
      },
      error: (error: any) => {}
    });
  }

}
